<template>
  <div class="flex items-center">
    {{ project_data.sales_price_range[0] }} - {{ project_data.sales_price_range[1] }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererSalesPriceRange',
  computed: {
  }
}
</script>
